"use client";
import SectionPage from "@/components/common/section-page";

import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import { useNavigate } from "react-router-dom";

export default function Home() {
    const navigate = useNavigate();

    return (
        <div className={"flex flex-col gap-6 pb-6 mb-8"}>


            <EspaceProTitleCard title={"Ressources du Tourisme Responsable"}
                                middleBreadcrumbs={[{title: "L’Office et Vous", link: "/espace-pro/office-et-vous"}]}
                                description={"Découvrez les missions et la vision de cette structure dotée de ressources importantes au cœur de l’écosystème touristique ivoirien."} />

            {/* Nature & Biodiversité */}
            <SectionPage sectionType="lg">
               <div className={"grid grid-cols-1 md:grid-cols-3 gap-6 mt-8"}>
                   <img src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/1.jpg" alt="image"/>
                   <div className={"md:col-span-2"}>
                       <h3 className={"font-playfair-display-italic text-5xl font-bold mb-4"}>Charte <br/>éco-responsable</h3>
                       <p className={"text-normal mb-8"}>
                           Nous vous proposons d’unir ensemble nos engagements et actions en adhérant à cette charte éco-responsable, qui s’inscrit dans une stratégie de développement touristique globale, en lien avec le ministère de l’environnement et du développement durable.
                           <br/><br/>
                           Les objectifs de cette démarche sont d’accompagner les professionnels, de mettre en valeur les actions engagées et de développer un tourisme responsable sur le territoire.

                       </p>
                   </div>
               </div>
            </SectionPage>


            <SectionPage sectionType="lg">
               <div className={"grid grid-cols-1 md:grid-cols-3 gap-8 mt-12"}>
                   {/** Sensiblisation - communication **/}
                   <div>
                       <img src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/2.jpg" alt="image"/>
                       <h3 className={"font-playfair-display-italic text-3xl font-bold my-4"}>Sensibilisation - Communication</h3>
                       <ul className={"text-normal mb-8 list-disc list-inside"}>
                           <li className="text-rose"><a
                               href="/pdf-viewer/Charte-du-Voyageur.pdf"
                               target="_blank" rel="noopener">Charte du voyageur</a></li>
                           <li className="li1">COTE D’IVOIRE, une destination durable</li>
                           <li className="li1">Eco-geste</li>
                           <li className="li1">Guide des démarches de classement</li>
                           <li className="li1">Guide des démarches de certification</li>
                       </ul>
                   </div>

                   {/** Achats durables, économie locale et producteurs locaux **/}
                   <div>
                       <img src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/3.jpg" alt="image"/>
                       <h3 className={"font-playfair-display-italic text-3xl font-bold my-4"}>Achats durables,
                           économie locale
                           et producteurs locaux</h3>
                       <ul className={"text-normal mb-8 list-disc list-inside"}>

                           <li className="li1 text-rose"><a
                               href="/pdf-viewer/Savoir-faire-Artisanal.pdf"
                               target="_blank" rel="noopener">Nos savoir-faire artisanaux</a></li>
                           <li className="li1">Nos artisans d’art<br/></li>
                           <li className="li1">Catalogue des producteurs locaux</li>
                       </ul>
                   </div>

                   {/** Biodiversité **/}
                   <div>
                       <img
                           src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/4.jpg"
                           alt="image"/>
                       <h3 className={"font-playfair-display-italic text-3xl font-bold my-4"}>Biodiversité</h3>
                       <div className={"md:h-48 overflow-y-auto pl-4"}>
                           <ul className={"text-normal mb-8 list-disc list-inside"}>

                               <li className="li1 text-rose"><a
                                   href="/pdf-viewer/Atlas-de-la-biodiversite-ivoirienne.pdf">Atlas
                                   de la biodiversité ivoirienne</a></li>
                           </ul>

                           <p className="p2">L’Atlas de la Biodiversité a pour objectif :</p>

                           <ul className="text-normal mb-8 list-disc list-inside">
                               <li className="li2">D’identifier la biodiversité</li>
                               <li className="li2">De sensibiliser les opérateurs et les populations au planting d’arbre
                               </li>
                               <li className="li2">D’améliorer l’environnement immédiat</li>
                               <li className="li2">De sensibiliser pour l’action et la mobilisation locale sur la
                                   biodiversité
                               </li>
                               <li className="li2">D’être un outil d’aide à la décision permettant une meilleure
                                   appréhension des futurs aménagements et de leurs impacts environnementaux
                               </li>
                               <li className="li2">De sensibiliser, de former et d’impliquer les acteurs et habitants du
                                   territoire
                               </li>
                               <li className="li2">Vous avez vu un animal insolite de compagnie&nbsp;? partager&nbsp;!</li>
                           </ul>
                       </div>
                   </div>

                   {/** Prévention des déchets **/}
                   <div>
                       <img
                           src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/5.jpg"
                           alt="image"/>
                       <h3 className={"font-playfair-display-italic text-3xl font-bold my-4"}>Prévention des déchets</h3>

                       <ul className="text-normal mb-8 list-disc list-inside">
                           <li className="li1 text-rose"><a
                               href="/pdf-viewer/Kit-eco-Gestes.pdf"
                               target="_blank" rel="noopener">Kit Eco-gestes</a></li>
                           <li className="li1 text-rose"><a
                               href="/pdf-viewer/Le-tri-dans-les-etablissements-recevant-du-public-copie.pdf"
                               target="_blank" rel="noopener">Le tri dans les établissements recevant du public</a></li>
                           <li className="li1">Les artisans, acteurs de la réduction des déchets (Se faire répertorier
                               dans l’annuaire)
                           </li>
                       </ul>
                   </div>

                   {/** Gestion de l'énergie **/}
                   <div>
                       <img
                           src="/images/espace-pro/office-et-vous/centre-de-ressources/ressource-tourisme-responsable/6.jpg"
                           alt="image"/>
                       <h3 className={"font-playfair-display-italic text-3xl font-bold my-4"}>Gestion de l'énergie</h3>

                       <ul className="text-normal mb-8 list-disc list-inside">
                           <li className="li1 text-rose"><a
                               href="/pdf-viewer/Aide-Eco-Transition-1.pdf"
                               target="_blank" rel="noopener">Aide éco-transition</a></li>
                       </ul>
                   </div>
               </div>
            </SectionPage>


        </div>
    );
}
